import Appointment from '../appointments/appointmentModel'
import Location from '../locations/locationModel'

export default class Schedule {
  location: Location
  hours_of_operation: any
  spots: any
  day: string
  day_of_week: string
  day_of_week_abbr: string
  is_open: string
  appointments: Appointment[]
  remainingAppts: Appointment[]
  slotAppointmentInfo: any

  constructor (instance: any) {
    this.location = instance.location
    this.hours_of_operation = instance.hours_of_operation
    this.spots = instance.spots
    this.day = instance.day
    this.day_of_week = instance.day_of_week
    this.day_of_week_abbr = instance.day_of_week_abbr
    this.is_open = instance.is_open
  }
}
